// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "rescript/lib/es6/belt_Option.js";

function resultOptionToBool(res, defaultBool) {
  return Belt_Option.mapWithDefault(res, defaultBool, (function (x) {
                if (x.TAG === /* Ok */0) {
                  return true;
                } else {
                  return false;
                }
              }));
}

function isInfoFinished(form) {
  if (resultOptionToBool(form.actionTypeResult, false) && resultOptionToBool(form.actionLabelResult, false)) {
    if (form.input.orderGroup === /* VE_AD */2) {
      return resultOptionToBool(form.isPARCExitResult, false);
    } else {
      return true;
    }
  } else {
    return false;
  }
}

function isPerfInfoFinished(form) {
  if (resultOptionToBool(form.actionTypeResult, false) && resultOptionToBool(form.actionLabelResult, false)) {
    return resultOptionToBool(form.perfTypeResult, false);
  } else {
    return false;
  }
}

function isDetailREPRFinished(form, formGeneralDates) {
  if (resultOptionToBool(form.budgetTypeResult, false) && resultOptionToBool(formGeneralDates.startDateResult, false) && resultOptionToBool(formGeneralDates.endDateResult, false) && resultOptionToBool(formGeneralDates.deliveryStartDateResult, true) && resultOptionToBool(formGeneralDates.deliveryEndDateResult, true) && resultOptionToBool(formGeneralDates.registrationStartDateResult, true) && resultOptionToBool(formGeneralDates.registrationEndDateResult, true) && resultOptionToBool(form.valueResult, false)) {
    return resultOptionToBool(form.numberTypeResult, false);
  } else {
    return false;
  }
}

function isDetailNonSOFinished(form, formGeneralDates) {
  if (form.input.orderGroup === /* VE_AD */2) {
    if ((
        Belt_Option.getWithDefault(form.input.isPARCExit, false) ? resultOptionToBool(form.exitParcDatePeriodStartResult, false) && resultOptionToBool(form.exitParcDatePeriodEndResult, false) && resultOptionToBool(form.detentionMinResult, false) && resultOptionToBool(form.detentionMaxResult, false) : resultOptionToBool(form.entryParcDatePeriodStartResult, false) && resultOptionToBool(form.entryParcDatePeriodEndResult, false)
      ) && resultOptionToBool(form.valueResult, false)) {
      return resultOptionToBool(form.numberTypeResult, false);
    } else {
      return false;
    }
  } else if (resultOptionToBool(formGeneralDates.startDateResult, form.input.orderGroup === /* RR */5 || form.input.orderGroup === /* RC */6) && resultOptionToBool(formGeneralDates.endDateResult, form.input.orderGroup === /* RR */5 || form.input.orderGroup === /* RC */6) && resultOptionToBool(formGeneralDates.deliveryStartDateResult, true) && resultOptionToBool(formGeneralDates.deliveryEndDateResult, true) && resultOptionToBool(formGeneralDates.registrationStartDateResult, true) && resultOptionToBool(formGeneralDates.registrationEndDateResult, true) && resultOptionToBool(form.valueResult, false)) {
    return resultOptionToBool(form.numberTypeResult, false);
  } else {
    return false;
  }
}

function datesAreBothSome(start, end) {
  if (Belt_Option.isSome(start)) {
    return Belt_Option.isSome(end);
  } else {
    return false;
  }
}

function isDetailRRorRCFinished(form, formGeneralDates) {
  if (resultOptionToBool(form.entryParcDatePeriodStartResult, true) && resultOptionToBool(form.entryParcDatePeriodEndResult, true) && (
      Belt_Option.getWithDefault(form.input.isPARCExit, false) ? true : resultOptionToBool(form.detentionMinResult, true) && resultOptionToBool(form.detentionMaxResult, true)
    ) && resultOptionToBool(formGeneralDates.startDateResult, true) && resultOptionToBool(formGeneralDates.endDateResult, true) && resultOptionToBool(formGeneralDates.deliveryStartDateResult, true) && resultOptionToBool(formGeneralDates.deliveryEndDateResult, true) && resultOptionToBool(formGeneralDates.registrationStartDateResult, false) && resultOptionToBool(formGeneralDates.registrationEndDateResult, false) && resultOptionToBool(form.valueResult, false)) {
    return resultOptionToBool(form.numberTypeResult, false);
  } else {
    return false;
  }
}

var Form;

var FormGeneralDates;

export {
  Form ,
  FormGeneralDates ,
  resultOptionToBool ,
  isInfoFinished ,
  isPerfInfoFinished ,
  isDetailREPRFinished ,
  isDetailNonSOFinished ,
  datesAreBothSome ,
  isDetailRRorRCFinished ,
}
/* No side effect */
